import React, { useState, useEffect } from 'react';

// Tracks the active theme by observing the data-theme attribute on <html>,
// so the logo swaps instantly when ThemeToggle flips the theme.
function useThemeName() {
  const [theme, setTheme] = useState(() =>
    document.documentElement.getAttribute('data-theme') === 'light' ? 'light' : 'dark'
  );
  useEffect(() => {
    const el = document.documentElement;
    const update = () =>
      setTheme(el.getAttribute('data-theme') === 'light' ? 'light' : 'dark');
    const obs = new MutationObserver(update);
    obs.observe(el, { attributes: true, attributeFilter: ['data-theme'] });
    return () => obs.disconnect();
  }, []);
  return theme;
}

// Theme- and collapse-aware brand logo. Keeps the exported colors
// (gold #facc15 on dark, black on light). Falls back to a text wordmark
// if the SVG asset cannot be loaded.
export function Logo({ collapsed = false }) {
  const theme = useThemeName();
  const [failed, setFailed] = useState(false);

  if (failed) {
    return <span className="logo logo-fallback">{collapsed ? 'WG' : 'WeGolden'}</span>;
  }

  const form = collapsed ? 'symbol' : 'logo';
  const src = `/wegolden-${form}-${theme}.svg`;
  return (
    <img
      className="logo logo-img"
      src={src}
      alt="WeGolden"
      onError={() => setFailed(true)}
    />
  );
}
